import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import BaseDayPicker from 'modules/core/components/DayPicker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { firstDayOfWeekAsIndex } from 'modules/core/lib/firstDayOfWeek'

type BaseDayPickerProps = React.ComponentProps<typeof BaseDayPicker>

export type DayPickerProps = Omit<
  BaseDayPickerProps,
  'onChange' | 'mode' | 'missingLabel' | 'selectValue'
> & {
  onChange?: (field: Field) => void
  field: Field
}

const DayPicker = ({ value, onChange, field, ...restProps }: DayPickerProps) => {
  const {
    access: { firstDayOfWeek },
  } = useCurrentSession()
  const error = !field.isDirty ? field.errors && field.errors[0] : null

  function onChangeEvent(date: string) {
    if (!field) return

    field.set(date)
    onChange && onChange(field)
  }

  return (
    <BaseDayPicker
      {...restProps}
      onChange={onChangeEvent}
      value={value || field.value || ''}
      error={error || undefined}
      firstDayOfWeek={firstDayOfWeekAsIndex(firstDayOfWeek)}
    />
  )
}

export default observer(DayPicker)
